
import React, { useState } from 'react';
import { Separator } from "./ui/separator";

type PropertyDescriptionProps = {
  description: string;
  shortDescription?: string;
};

const PropertyDescription: React.FC<PropertyDescriptionProps> = ({ 
  description,
  shortDescription
}) => {
  const [expanded, setExpanded] = useState(false);
  
  // Si shortDescription est fourni, utilisez-le comme version courte
  // Sinon, limitez description à 250 caractères pour la version courte
  const shortDesc = shortDescription || (description.length > 250 
    ? `${description.substring(0, 250)}...` 
    : description);
  
  return (
    <div className="py-6 animate-fade-in">
      <div className="text-lg space-y-4">
        {expanded ? (
          <div>
            {description.split('\n').map((paragraph, idx) => (
              <p key={idx} className="mb-4">{paragraph}</p>
            ))}
            <button 
              onClick={() => setExpanded(false)}
              className="mt-2 font-medium text-rental-secondary underline"
            >
              Afficher moins
            </button>
          </div>
        ) : (
          <div>
            {shortDesc.split('\n').map((paragraph, idx) => (
              <p key={idx} className="mb-4">{paragraph}</p>
            ))}
            {description.length > 250 && (
              <button 
                onClick={() => setExpanded(true)}
                className="mt-2 font-medium text-rental-secondary underline"
              >
                Afficher plus
              </button>
            )}
          </div>
        )}
      </div>
      
      <Separator className="my-6" />
    </div>
  );
};

export default PropertyDescription;
